import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
const SvgCroatia = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        style: {
            enableBackground: "new 0 0 512 512"
        },
        xmlSpace: "preserve",
        width: "1em",
        height: "1em",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#41479b"
                },
                d: "M0 341.333h512V368c0 79.529-64.471 144-144 144H144C64.471 512 0 447.529 0 368v-26.667z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#ff4b55"
                },
                d: "M512 111.913C511.953 50.097 461.828 0 400.001 0h-288c-61.856 0-112 50.144-112 112v58.667H512v-58.754z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#f5f5f5"
                },
                d: "M0 170.67h512v170.67H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#ff4b55"
                },
                d: "M161.68 175.16h37.726v43.12H161.68zM237.14 175.16h37.726v43.12H237.14zM199.41 218.27h37.726v43.12H199.41zM312.59 175.16h37.726v43.12H312.59z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#ff4b55"
                },
                d: "M274.86 218.27h37.726v43.12H274.86z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#f5f5f5"
                },
                d: "M199.41 175.16h37.726v43.12H199.41zM274.86 175.16h37.726v43.12H274.86zM161.68 218.27h37.726v43.12H161.68z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#f5f5f5"
                },
                d: "M237.14 218.27h37.726v43.12H237.14zM312.59 218.27h37.726v43.12H312.59z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#ff4b55"
                },
                d: "M237.14 261.39h37.726v43.12H237.14zM199.41 304.51h37.726v43.12H199.41zM274.86 304.51h37.726v43.12H274.86z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#f5f5f5"
                },
                d: "M199.41 261.39h37.726v43.12H199.41zM274.86 261.39h37.726v43.12H274.86zM237.14 304.51h37.726v43.12H237.14z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#ff4b55"
                },
                d: "M350.316 175.157V296.42c0 52.089-42.227 94.316-94.316 94.316s-94.316-42.227-94.316-94.316V175.157h188.632m6.737-6.736H154.947v128c0 55.72 45.332 101.053 101.053 101.053s101.053-45.332 101.053-101.053v-128z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#ff4b55"
                },
                d: "M199.41 304.505v-43.116h-37.726v35.032c0 2.729.181 5.414.408 8.084h37.318z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#f5f5f5"
                },
                d: "M349.908 304.505H312.59v43.116h22.549a93.666 93.666 0 0 0 14.769-43.116zM176.861 347.62h22.549v-43.116h-37.318a93.67 93.67 0 0 0 14.769 43.116z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#ff4b55"
                },
                d: "M312.59 304.505h37.318c.227-2.67.408-5.354.408-8.084v-35.032H312.59v43.116zM199.41 371.745v-24.124h-22.549c6.042 9.319 13.695 17.461 22.549 24.124zM335.139 347.62H312.59v24.124c8.854-6.662 16.507-14.804 22.549-24.124z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#f5f5f5"
                },
                d: "M199.41 371.745c10.981 8.264 23.761 14.263 37.726 17.098v-41.222H199.41v24.124zM274.864 388.843c13.965-2.835 26.745-8.834 37.726-17.098v-24.124h-37.726v41.222z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#ff4b55"
                },
                d: "M274.864 347.62h-37.727v41.222a94.691 94.691 0 0 0 18.864 1.894c6.46 0 12.768-.656 18.863-1.894V347.62z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#4173cd"
                },
                d: "M187.729 103.812a275.865 275.865 0 0 0-25.167-2.715 290.346 290.346 0 0 0-18.924 17.018l18.046 43.568a246.583 246.583 0 0 1 37.009-12.007l-10.964-45.864zM278.899 96.66A282.162 282.162 0 0 0 256 86.334a282.697 282.697 0 0 0-22.899 10.326l3.678 47.014a246.182 246.182 0 0 1 38.442 0l3.678-47.014zM368.362 118.116a290.346 290.346 0 0 0-18.924-17.018 276.613 276.613 0 0 0-25.167 2.715l-10.965 45.865a246.47 246.47 0 0 1 37.009 12.007l18.047-43.569z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#41479b"
                },
                d: "M233.101 96.66a279.776 279.776 0 0 0-24.26-6.635 286.514 286.514 0 0 0-21.112 13.787l10.965 45.865a246.188 246.188 0 0 1 38.085-6.003l-3.678-47.014zM324.271 103.812a286.614 286.614 0 0 0-21.112-13.787 279.874 279.874 0 0 0-24.26 6.635l-3.678 47.014a246.429 246.429 0 0 1 38.085 6.003c3.655-15.288 7.311-30.576 10.965-45.865z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#ff4b55"
                },
                d: "M234.572 115.466a274.551 274.551 0 0 0-42.457 6.692l-2.193-9.174a284.41 284.41 0 0 1 43.914-6.922l.736 9.404zM236.043 134.271a256.047 256.047 0 0 0-39.542 6.233c-.732-3.057-1.462-6.116-2.193-9.173a265.056 265.056 0 0 1 41-6.463l.735 9.403z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#ffe15a"
                },
                d: "M300.762 137.436a255.43 255.43 0 0 0-9.893-1.559c-5.436-.751-9.485-5.366-9.014-10.555.47-5.185 5.668-8.948 11.585-8.132 3.548.489 7.09 1.046 10.622 1.674 5.889 1.04 9.703 6.229 8.554 11.305-1.148 5.085-6.439 8.221-11.854 7.267z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#ff4b55"
                },
                d: "M353.925 152.97a255.946 255.946 0 0 0-38.426-12.466c.732-3.057 1.462-6.116 2.193-9.173a265.106 265.106 0 0 1 39.842 12.925c-1.202 2.905-2.406 5.809-3.609 8.714z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#ffe15a"
                },
                d: "M350.559 124.674c-1.333 3.674-5.826 5.422-10.072 4.041-4.245-1.382-6.842-5.419-5.768-9.176 1.075-3.757 5.625-5.746 10.13-4.283 4.505 1.461 7.043 5.745 5.71 9.418zM177.281 119.539c1.074 3.761-1.527 7.798-5.768 9.176-4.244 1.375-8.738-.373-10.072-4.041-1.335-3.674 1.206-7.957 5.71-9.418 4.502-1.459 9.058.528 10.13 4.283zM253.848 113.364c.009 3.125-2.8 5.669-6.279 5.775-3.478.112-6.444-2.26-6.627-5.373-.182-3.114 2.625-5.808 6.275-5.927 3.651-.115 6.617 2.4 6.631 5.525zM271.058 113.766c-.186 3.118-3.151 5.484-6.628 5.373-3.478-.107-6.288-2.651-6.279-5.775.013-3.121 2.98-5.642 6.631-5.525 3.653.11 6.456 2.811 6.276 5.927zM262.117 127.911c-.087 3.125-2.825 5.582-6.117 5.581-3.292-.002-6.028-2.456-6.117-5.581-.085-3.115 2.651-5.732 6.117-5.724 3.466-.006 6.203 2.607 6.117 5.724z"
            })
        ]
    });
export { SvgCroatia };
